import React from "react";
import { Navigate } from "react-router-dom";
import { EuiProgress } from "@elastic/eui";
import useAuthUser from "hooks/useAuthUser";
import { COLORS } from "Consts";

interface PrivateRouteProps {
  element: React.ReactNode;
}

const PrivateRouteWrapper: React.FC<PrivateRouteProps> = ({ element }) => {
  const { isLoggedIn, attemptedFetch } = useAuthUser();

  if (!attemptedFetch) {
    return <EuiProgress color={COLORS.$progressGreen} size="xs" />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return <>{element}</>;
};

export default PrivateRouteWrapper;
